import React, { useMemo, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  InputAdornment,
  List,
  TextField,
} from "@mui/material";
import {
  countryLabel,
  noOptionsFound,
  search,
  select,
  selectCountry,
} from "./messages";
import { Input } from "./input/Input";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DialogBox from "./dialog/Dialog";
import SearchIcon from "@mui/icons-material/Search";
import { countries } from "./country";
import Text from "./text/Text";

const SelectCountryDropdown = ({
  formik,
  customClass,
  countryFromResponse,
}) => {
  const [isSelectCountryModalOpen, setIsSelectCountryModalOpen] =
    useState(false);
  const [searchValue, setSearchValue] = useState("");

  const { values, setFieldValue } = formik;

  const closeCountryModal = () => {
    setIsSelectCountryModalOpen(false);
  };

  const filteredCountries = useMemo(() => {
    return countries?.filter((x) =>
      x.short_name?.toLowerCase().includes(searchValue?.toLowerCase())
    );
  }, [countries, searchValue]);

  return (
    <>
      <Input
        customClass={`mt-16 cursor-pointer ${customClass}`}
        value={values?.country}
        fullWidth
        showLabel
        label={countryLabel}
        placeholder={select}
        onClick={() => setIsSelectCountryModalOpen(true)}
        disabled={countryFromResponse}
        endAdornment={
          !countryFromResponse && (
            <InputAdornment position="end" sx={{ mr: 1 }}>
              <KeyboardArrowDownIcon
                style={{
                  width: 21,
                  height: 25,
                  color: "#848B9E",
                }}
              />
            </InputAdornment>
          )
        }
      />
      <DialogBox
        isOpenModal={isSelectCountryModalOpen}
        setIsOpenModal={setIsSelectCountryModalOpen}
        modalHeader={selectCountry}
        handleAction={closeCountryModal}
        directionToOpen="up"
      >
        <Box className="country-dropdown">
          <TextField
            className="auto-complete-country"
            placeholder={search}
            name="country"
            value={searchValue}
            onChange={(e) => setSearchValue(e?.target?.value)}
            inputProps={{
              autoComplete: "off",
              autoFocus: false,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment>
                  <SearchIcon sx={{ color: "#848B9E" }} />
                </InputAdornment>
              ),
            }}
          />
          <Card
            className="country-list-container"
            sx={{
              height: "100%",
            }}
          >
            <CardContent sx={{ p: "0 !important" }}>
              {filteredCountries?.length > 0 ? (
                <List sx={{ p: "0 !important", mt: "20px" }}>
                  {filteredCountries?.map((option) => {
                    return (
                      <Box
                        key={option.id}
                        sx={{
                          p: "8px 0px",
                          height: "24px",
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                        className="cursor-pointer"
                        onClick={() => {
                          setSearchValue("");
                          if (values.country !== option.short_name)
                            setFieldValue("state", "");
                          setFieldValue(
                            "country",
                            option && typeof option === "object"
                              ? option.short_name
                              : option
                          );
                          closeCountryModal();
                        }}
                      >
                        <Text
                          sx={{ color: "#101828" }}
                          font="semibold"
                          size={16}
                        >
                          {option?.short_name}
                        </Text>
                        <Text
                          sx={{ color: "#101828" }}
                          font="semibold"
                          size={16}
                        >
                          {option?.iso2}
                        </Text>
                      </Box>
                    );
                  })}
                </List>
              ) : (
                <Box
                  sx={{
                    p: "8px 0px",
                    height: "32px",
                    width: "100%",
                  }}
                >
                  <Text sx={{ color: "#101828" }} font="semibold" size={16}>
                    {noOptionsFound}
                  </Text>
                </Box>
              )}
            </CardContent>
          </Card>
        </Box>
      </DialogBox>
    </>
  );
};

export default SelectCountryDropdown;
